import Phaser from 'phaser';
import * as ABCya from '@abcya/abcya_phaser';

//Using game as the primary sound manager scene
//Ties functions to the scene that are callable by other scenes - 
//or just create the functions here, and have them auto bind to the scene they are created from

export default class soundManager
{
    /**
     * 
     * @param {Phaser.scene} scene 
     */
    constructor(scene)
    {
        this.scene = scene;
        this.tracks = {};
        this.soundLib = new Map();
    }

    createTrack(trackKey)
    {
        this.tracks[trackKey] = {manager:ABCya.Audio.createSound(this.scene),customMute:false};
        this.tracks[trackKey].manager.name = trackKey;

        return this.tracks[trackKey].manager;
    }

    /**
     * Sound Manager playsound - see SoundManagerClass
     * @param {*} soundKey 
     * @param {*} volume 
     * @param {*} loop 
     * @param {*} delay 
     */
    playSoundCustom(soundKey,volume=1,loop=false,delay=0)
    {
        if(this.soundLib.has(soundKey))
        {
            const track = this.soundLib.get(soundKey);
            //ABCya.Audio.playSound(soundKey,track,volume,loop,delay);
            if(!this.tracks[track.name].customMute)
            {
                track.play(soundKey,{volume:volume,loop:loop,delay:delay,mute:track.mute});
                return track;
            }

        }
        else console.log(`*****${soundKey} is not in the sound lib*****`);
    }

    /** Will check to make sure the current track is not playing another sound before playing
     * 
     * @param {*} soundKey 
     * @param {*} volume 
     * @param {*} loop 
     * @param {*} delay 
     * @returns 
     */
    playSoundNoOverlap(soundKey,volume=1,loop=false,delay=0)
    {
        if(this.soundLib.has(soundKey))
        {
            const track = this.soundLib.get(soundKey);
            //ABCya.Audio.playSound(soundKey,track,volume,loop,delay);
            if(!this.tracks[track.name].customMute && !track.isPlaying)
            {
                track.play(soundKey,{volume:volume,loop:loop,delay:delay,mute:track.mute});
                return track;
            }
        }
        else console.log(`*****${soundKey} is not in the sound lib*****`);
    }

    muteAllTracksExcept(trackKey)
    {
        for(let each in this.tracks)
        {
            if(each != trackKey)
            {
                this.tracks[each].customMute = true;
                this.tracks[each].manager.pause();
            }
        }
    }

    unmuteAllTracks()
    {
        for(let each in this.tracks)
        {
            this.tracks[each].customMute = false;
            this.tracks[each].manager.manager.resumeAll();
        }
    }
}